import { useEffect, useState } from "react";
import { Globe2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel, Tag, Alert } from "@/components/common";

export default function LandingDomain() {
  const [info, setInfo] = useState(null);
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  useEffect(() => { api.get("/settings/app").then((r) => { setInfo(r.data); setValue(r.data.source === "settings" ? r.data.base : ""); }); }, []);
  const save = async (e) => {
    e.preventDefault();
    setError("");
    try { const { data } = await api.put("/settings/app", { landing_page_base_url: value }); setInfo(data); toast.success("Landing page domain saved"); }
    catch (err) { setError(errMsg(err)); }
  };
  return (
    <Panel title="Landing page domain" icon={Globe2} testid="landing-domain-panel">
      <p className="mb-4 text-sm text-slate-400">Every ad final URL is built from this domain (<span className="font-mono">{"{domain}"}/lp/{"{slug}"}</span>). Planned: <span className="font-mono text-slate-200">https://go.therehablabsg.com</span></p>
      <form onSubmit={save} className="flex flex-col gap-3 md:flex-row">
        <input data-testid="landing-domain-input" className="cc-input font-mono" placeholder="https://go.therehablabsg.com" value={value} onChange={(e) => setValue(e.target.value)} />
        <button data-testid="landing-domain-save" className="cc-btn cc-btn-primary whitespace-nowrap">Save domain</button>
      </form>
      {error && <div data-testid="landing-domain-error" className="mt-2 text-sm text-red-300">{error}</div>}
      {info && (
        <div className="mt-4 space-y-3">
          <div className="flex flex-wrap items-center gap-2 font-mono text-xs text-slate-400" data-testid="landing-domain-effective">
            In use: <span className="text-slate-200">{info.base}</span> <Tag>{info.source}</Tag>
          </div>
          {info.is_preview && <Alert tone="amber" title="Ads can't go live on this domain" testid="landing-domain-warning">Deploy and connect go.therehablabsg.com before going live. Proposals whose final URL is on *.preview.emergentagent.com are blocked.</Alert>}
        </div>
      )}
    </Panel>
  );
}
